import { useEffect, useRef, useState } from "react";

export default function UserSearchSelect({
  users = [],
  value,
  onChange,
  placeholder = "Search user…",
}) {
  const [query,  setQuery]  = useState("");
  const [open,   setOpen]   = useState(false);
  const wrapRef  = useRef(null);
  const inputRef = useRef(null);

  const selected = users.find(u => u.id === value) || null;
  const displayValue = open ? query : (selected ? (selected.display_name || selected.user_name) : "");

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = (q
    ? users.filter(u =>
        (u.display_name || "").toLowerCase().includes(q) ||
        (u.user_name    || "").toLowerCase().includes(q)
      )
    : users
  ).slice(0, 60);

  const handleFocus = () => { setOpen(true); setQuery(""); };
  const handleInput = (e) => {
    setQuery(e.target.value);
    setOpen(true);
    if (!e.target.value) onChange("");
  };
  const handleSelect = (u) => { onChange(u.id); setOpen(false); setQuery(""); };
  const handleClear  = (e) => {
    e.stopPropagation();
    onChange("");
    setQuery("");
    setOpen(false);
    inputRef.current?.focus();
  };

  return (
    <div className={`v2drw-ss${open ? " open" : ""}`} ref={wrapRef}>
      <div className="v2drw-ss-wrap">
        <input
          ref={inputRef}
          type="text"
          className="v2drw-ss-input"
          value={displayValue}
          placeholder={placeholder}
          onFocus={handleFocus}
          onChange={handleInput}
        />
        {selected && !open ? (
          <button
            className="v2drw-ss-clear"
            onMouseDown={e => e.preventDefault()}
            onClick={handleClear}
            tabIndex={-1}
          >×</button>
        ) : (
          <svg className="v2drw-ss-chev" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        )}
      </div>
      {open && (
        <div className="v2drw-ss-drop">
          <div className="v2drw-ss-list">
            {filtered.length === 0 && (
              <div className="v2drw-ss-empty">No matches</div>
            )}
            {filtered.map(u => (
              <div
                key={u.id}
                className={`v2drw-ss-opt${u.id === value ? " on" : ""}`}
                onMouseDown={e => e.preventDefault()}
                onClick={() => handleSelect(u)}
              >
                {u.display_name || u.user_name}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
